import styled from 'styled-components';
import {
  Radio as SemanticRadio,
  Checkbox as SemanticCheckbox,
} from 'semantic-ui-react';

export const Radio = styled(SemanticRadio)`
  margin-bottom: 5px;
`;

export const Checkbox = styled(SemanticCheckbox)`
  margin-bottom: 5px;
`;
